import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "categoryName",
    standalone: false
})
export class CategoryNamePipe implements PipeTransform {
  transform(value: any, catList: any): string {
    let selected =
      catList &&
      catList.filter(function (module: any) {
        return module.id == value;
      });
    if (selected && selected[0]) return selected[0].name;
    else return "";
  }
}
